export default "__VITE_ASSET__DcRvhfMY__"